import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import Destinations from './components/Destinations';
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={scrolled} />
      <Hero />
      <Services />
      <Destinations />
      <Process />
      <Testimonials />
      <Footer />
    </div>
  );
}
